/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

/* eslint-disable camelcase */
import { en_us as English } from "./en_us_core";
import { fr_ca as French } from "./fr_ca_core";
import { es_mx as Spanish } from "./es_mx_core";

const stringsProvider = (locale) => {
  let core;
  switch (locale) {
    case "en_us":
      core = English;
      break;
    case "fr_ca":
      core = French;
      break;
    case "es_mx":
      core = Spanish;
      break;
    default:
      core = English;
  }

  return {
    nx_components: {
      schedules: {
        EditPeriod: {
          cannotBeBlank: core[313],
          noSpecialCharacters: core[314],
          applyChanges: core[49],
        },
        Footer: {
          addPeriod: core[31],
          removePeriod: core[230],
          done: core[107],
          undo: core[291],
          cancelButton: core[69],
          applyButton: core[44],
        },
        ScrollableWithIndicators: {
          more: core[185],
        },
        ThermostatSchedule: {
          cannotCreateTemplate: core[70],
          newPeriod: core[190],
          precedingPeriod: core[276],
          followingPeriod: core[275],
          unoccupied: core[298],
          occupied: core[201],
          mustHaveOnePeriod: core[22],
          cannotDelete: core[309],
        },
        utils: {
          precedingPeriod: core[276],
          followingPeriod: core[275],
        },
        Schedule: {
          mon: core[388],
          tue: core[389],
          wed: core[390],
          thu: core[391],
          fri: core[392],
          sat: core[393],
          sun: core[394],
        },
      },
      PivotThermostatSetpointControls: {
        heatTo: core[140],
        coolTo: core[87],
      },
      ThermostatDetailsHeader: {
        outside: core[209],
        humidity: core[148],
        compressorSpeed: core[80],
      },
      ThermostatHighLowAlertControls: {
        alertHigh: core[33],
        alertLow: core[34],
      },
      ThermostatSetpointControls: {
        heatTo: core[140],
        coolTo: core[87],
      },
      ThermostatSetpoints: {
        coolToHeatTo: core[89],
        heatToCoolTo: core[142],
        heatTo: core[141],
        coolTo: core[88],
      },
      ThermostatStatusPane: {
        outside: core[209],
        humidity: core[148],
        compressor: core[79],
      },
      TileControl: {
        Heat: core[373],
        Cool: core[374],
        Off: core[375],
      },
      ThermostatHumidityAlertControls: {
        alertHigh: core[396],
        alertLow: core[397],
      },
    },
    nexia_mobile: {
      pages: {
        ForgotCredentialsPage: {
          index: {
            usernameRequiredError: core[302],
            emailRequiredError: core[113],
            emailInvalidError: core[112],
            title: core[28],
            usernameCallToAction: core[122],
            usernameLabel: core[300],
            resetPasswordButton: core[231],
            passwordCallToAction: core[119],
            emailLabel: core[111],
            recoverUsernameButton: core[226],
          },
          ForgotCredentialsButton: {
            iForgotCredentials: core[149],
          },
          CredentialsRequestedDialog: {
            successPt1Template: core[272],
            successPt2Template: core[153],
            successPt3Template: core[131],
          },
        },
        LocalSettingsPage: {
          index: {
            title: core[43],
          },
          DealerOptInItem: {
            enableServiceContractor: core[115],
          },
          DeviceOrderingItem: {
            deviceOrderingLabel: core[99],
          },
          LogOutItem: {
            areYouSure: core[56],
            disassociateLabel: core[105],
            logoutLabel: core[176],
            yes: core[307],
            no: core[192],
          },
          RefreshDevicesItem: {
            networkUnavailable: core[312],
            refreshDevicesLabel: core[228],
          },
          ResetPinItem: {
            confirmChangePin: core[50],
            resetPinLabel: core[232],
          },
          UnlockAppItem: {
            caution: core[220],
            confirmRisk: core[150],
            pinUnlockMessage: core[320],
            biometricUnlockMessageTemplate: core[321],
            biometricUnlockLabel: core[295],
            pinUnlockOnlyLabel: core[297],
            pinUnlockLabel: core[296],
            noAuthorizationLabel: core[194],
            unlockAppLabel: core[294],
          },
          LanguageItem: {
            languageLabel: core[359],
          },
        },
        AccessRestrictionPage: {
          none: core[197],
          saving: core[244],
          saveSuccessful: core[25],
          applyToAdditional: core[47],
          yes: core[307],
          no: core[192],
          arNoneLabel: core[197],
          arLowLabel: core[178],
          arMediumLabel: core[181],
          arHighLabel: core[145],
          arNoneText: core[38],
          arLowText: core[104],
          arMediumText: core[103],
          arHighText: core[39],
          title: core[24],
          description: core[26],
          cancel: core[69],
          apply: core[44],
        },
        PinAccessPage: {
          title: core[236],
          descriptionPt1: core[234],
          descriptionPt2: core[156],
          cancel: core[69],
          apply: core[44],
          savingPinsMessage: core[323],
          pinSaveSuccessToast: core[324],
          applyPinsToAdditionalThermostats: core[325],
          yes: core[307],
          no: core[192],
          pinLengthError: core[326],
          mainPinCheckboxLabel: core[327],
          mainPinCheckboxHeader: core[328],
          techPinCheckboxLabel: core[329],
          techPinCheckboxHeader: core[330],
        },
        CreatePinEntryPage: {
          pinSaveSuccessfully: core[215],
          entriesDontMatch: core[123],
          setAPin: core[253],
          setAn8DigitPin: core[254],
          confirmPin: core[81],
        },
        ValidatePinEntryPage: {
          reauthPromptMessageTemplate: core[322],
          reauthSubmitButton: core[232],
          reauthTitle: core[232],
          reauthNewPinToast: core[219],
          pinDisabledTemplate: core[213],
          enterPin: core[120],
        },
        ThermostatAlertsPage: {
          savingAlerts: core[245],
          saveSuccessful: core[36],
          saveError: core[318],
          applyAlertsToAdditionalStats: core[48],
          yes: core[307],
          no: core[192],
          cancel: core[69],
          apply: core[44],
          title: core[35],
          faultsEnabled: core[315],
          highLowEnabled: core[146],
          humidityEnabled: core[398],
          faultAlert: core[412],
          enabled: core[413],
          disabled: core[414],
          highLowAlertTitle: core[415],
          humidityAlertTitle: core[416],
          above: core[417],
          below: core[418],
          AlertStatusText: core[419],
          AlertEnabled: core[420],
          Alert: core[421],
          highLowAlertError1: core[436],
          highLowAlertError2: core[437],
        },
        DeviceAdvancedInfoPage: {
          lastUpdated: core[157],
          title: core[32],
        },
        DeviceSettingsPage: {
          settings: core[259],
        },
        OccupancySetpointsPage: {
          occupiedLabel: core[201],
          unoccupiedLabel: core[298],
          savingSetpoints: core[316],
          saveSuccessful: core[317],
          saveError: core[318],
          applyToAdditionalStats: core[319],
          title: core[200],
          cancel: core[69],
          apply: core[44],
          yes: core[307],
          no: core[192],
        },
        WelcomePage: {
          logIn: core[175],
          exploreDemo: core[126],
          signUpNow: core[262],
        },
        SignInPage: {
          title: core[260],
          submit: core[266],
          pin: core[299],
          pointedToTemplate: core[223],
          usernameLabel: core[300],
          passwordLabel: core[370],
        },
        SignUpSchemaPage: {
          signUp: core[261],
          transferAccount: core[407],
          greeting: core[410],
          description: core[411],
          usernameInformation: core[422],
        },
        SignUpInfoPage: {
          continue: core[83],
          loading: core[163],
        },
        SignUpChallengePage: {
          continue: core[83],
        },
        SignUpComplete: {
          title: core[27],
          createdMessage: core[311],
          continue: core[83],
        },
        TransferAccountInfoPage: {
          continue: core[83],
          loading: core[409],
        },
        ResetPasswordPage: {
          errorToast: core[40],
          success: core[210],
          title: core[231],
          instructions: core[221],
          resetPassword: core[231],
          loading: core[170],
        },
        ActivatePhonePage: {
          title: core[29],
          enter12DigitCode: core[118],
        },
        AlertListPage: {
          loadingAlerts: core[164],
          clear: core[77],
          noAlertsActive: core[193],
          subscribeCallToAction: core[289],
          confirmCallToActionPt1: core[286],
          confirmCallToActionPt2: core[331],
          title: core[35],
          settingsButtonLabel: core[384],
          settingsButtonLabelForUsers: core[429],
          clearAll: core[78],
          clearAllConfirm: core[51],
          yes: core[307],
          no: core[192],
        },
        AlerterListEditPage: {
          title: core[429],
          save: core[241],
          name: core[187],
          sendTo: core[430],
          at: core[431],
          phoneNumber: core[432],
          emailAddress: core[110],
          all: core[433],
          none: core[197],
          custom: core[434],
          alertsLabel: core[435],
        },
        AlerterListUserPage: {
          title: core[423],
          addContact: core[425],
          description: core[426],
          editButtonLabel: core[427],
          deleteButtonLabel: core[428],
          pushNotificationTitle: core[438],
          description1: core[439],
        },
        CreateGroupPage: {
          loadingDevices: core[168],
        },
        ErrorPage: {
          somethingWentWrong: core[264],
          teamNotified: core[332],
          restartTheApp: core[233],
        },
        EventsPage: {
          title: core[124],
          noRecentActivity: core[196],
          dateToEarly: core[376],
          dateToLate: core[377],
          on: core[378],
          at: core[379],
          by: core[380],
          "Device Event": core[381],
          "Scheduled Event": core[382],
          "Web Browsers": core[383],
        },
        SupportPage: {
          deviceOfflineToast: core[284],
          operationCompleteToast: core[207],
          callSupportTemplate: core[68],
          emailSupport: core[114],
          sendSuggestionsOrFeedback: core[251],
          licenseInformation: core[158],
          termsAndConditionsLabel: core[270],
          helpDocumentationLabel: core[144],
          title: core[268],
          pivotMobleApp: core[217],
          loading: core[174],
          loginLabel: core[177],
          emailLabel: core[110],
          versionLabel: core[304],
          PasswordChangeMessage: core[395],
          passwordRequired: core[406],
        },
        NotFoundPage: {
          pageNotFound: core[333],
          goBack: core[135],
        },
        OpenSourceLicensePage: {
          title: core[206],
          description: core[274],
          acknowledgementText1: core[399],
          acknowledgementAddressLine1: core[400],
          acknowledgementAddressLine2: core[401],
          acknowledgementAddressLine3: core[402],
          acknowledgementAddressLine4: core[403],
          acknowledgementAddressLine5: core[404],
          acknowledgementText2: core[405],
        },
        PhonesPage: {
          title: core[303],
          newUserButton: core[191],
        },
        RuntimeHistoryPage: {
          dailyButtonLabel: core[94],
          montlyButtonLabel: core[184],
          loadingDaily: core[166],
          loadingMonthly: core[169],
          title: core[240],
        },
        SchemaEditPage: {
          savingMessage: core[334],
          deletingMessage: core[97],
          deleteConfirmationMessage: core[55],
          deleteConfirmationButton: core[96],
        },
        GroupDetailsPage: {
          loadingDevices: core[168],
          emptyGroupMessage: core[282],
          editGroupButton: core[109],
        },
        HomePage: {
          loadingBuilding: core[165],
        },
        InternetRequiredPage: {
          title: core[252],
          serviceUnavailableLabel: core[252],
          serviceUnavailableDescription: core[305],
          retryButton: core[239],
        },
        BuildingDashboardPage: {
          title: core[186],
          noDevicesTitle: core[186],
        },
        BuildingEditPage: {
          save: core[241],
        },
        BuildingsPage: {
          title: core[64],
          newBuilding: core[189],
        },
        ThermostatScheduleEditPage: {
          index: {
            activeScheduleTitle: core[365],
            discardConfirmation: core[340],
            discardButton: core[341],
            savedSchedulesTitle: core[243],
            emptySavedSchedulesMessage: core[310],
            loadButton: core[160],
            saveAsTitle: core[242],
            mustHaveANameWarning: core[342],
            SaveButton: core[241],
            initialSaveText: core[343],
          },
          actions: {
            savedAsNameTemplate: core[344],
            savingScheduleMessage: core[345],
            scheduleAlreadyExistsTemplate: core[346],
            yes: core[307],
            no: core[192],
            couldntLoadSchedule: core[347],
            scheduleInvalidTemplate: core[348],
            scheduleDoesNotMatchTempScaleTemplate: core[349],
            deletingScheduleTemplate: core[350],
            savingSchedule: core[351],
            savingSchedules: core[352],
            scheduleSaveSuccess: core[353],
            applyScheduleToAdditionalStats: core[354],
            loadedScheduleTemplate: core[355],
          },
        },
        PhoneEditPage: {
          saveButton: core[241],
          controllableThermostatsLabel: core[424],
        },
      },
      utils: {
        ajax_hooks: {
          reauthenticationToast: core[283],
        },
        backstage: {
          requestTimeout: core[277],
        },
        validateFields: {
          labelRequiredTemplate: core[5],
          labelDoesNotMatchTemplate: core[3],
          labelInvalidTemplate: core[4],
          labelExactLengthCharsTemplate: core[8],
          labelMinLengthCharsTemplate: core[13],
          labelMaxLengthCharsTemplate: core[9],
          labelMinNumberTemplate: core[12],
          labelMaxNumberTemplate: core[1],
          labelEarlyTemplate: core[6],
          labelLateTemplate: core[7],
        },
        flux_like: {
          network: {
            requestTimedOut: core[277],
          },
          pin: {
            invalidPinToast: core[154],
          },
        },
        ToastMsg: {
          dismiss: core[106],
        },
      },
      controls: {
        ActionButtons: {
          tellingActionTemplate: core[335],
        },
        ActivateUser: {
          newActivationConfirmation: core[152],
        },
        ThermostatDetailControls: {
          heatAndCoolToTemplate: core[258],
          heatToTemplate: core[257],
          coolToTemplate: core[256],
        },
        ThermostatModesControl: {
          modeChangeTemplate: core[73],
          applyToAdditionalStatsTemplate: core[45],
          yes: core[307],
          no: core[192],
        },
      },
      details: {
        BuildingDetails: {
          minOneBuilding: core[281],
          deleteConfirmation: core[53],
          delete: core[96],
          hasDevicesCannotDelete: core[336],
          nameLabel: core[187],
          postalCodeLabel: core[224],
          buildingDetailsLabel: core[66],
          devices: core[100],
          none: core[197],
        },
        BuildingHeader: {
          buildingConfiguration: core[64],
        },
        PhoneDetails: {
          deleteUserConfirmation: core[54],
          delete: core[96],
          platformLabel: core[218],
          manufacturerLabel: core[180],
          osVersionLabel: core[208],
          nameLabel: core[187],
          pivotAppVersionLabel: core[216],
          authTypeLabel: core[59],
          activationCodeType: core[30],
          usernamePasswordType: core[301],
          newActivationCode: core[188],
          getActivationCode: core[133],
          activationCode: core[30],
          deviceDetailsLabel: core[337],
        },
      },
      DeviceAdvancedSettingItemList: {
        accessRestrictionPageItem: {
          accessLevelLabel: core[235],
        },
        advancedInfoPageItem: {
          advancedLabel: core[32],
        },
        pinAccessPageItem: {
          passcodeLabel: core[236],
        },
        thermostatAlertsPageItem: {
          alertsLabel: core[35],
        },
        unenrollItem: {
          removeDeviceLabelTemplate: core[229],
          removeConfirmationTemplate: core[57],
          unenrollingTemplate: core[292],
        },
      },
      Toolbar: {
        DeviceDetailsToolbar: {
          loadingSchedule: core[173],
          scheduleLoadFailure: core[128],
          loadingScheduleList: core[171],
          loadingDefaultSchedule: core[167],
          thermostatNotconnected: core[338],
          scheduleDisabledEnableCallToAction: core[249],
          schedulesLabel: core[246],
          setpointsLabel: core[255],
          loadingSetpoints: core[172],
          eventsLabel: core[124],
          historyLabel: core[147],
          settingsLabel: core[259],
        },
        FilterItem: {
          clearButton: core[77],
          applyButton: core[44],
          filterLabel: core[385],
        },
        PivotScheduleChooser: {
          savedSchedulesTitle: core[243],
          emptyMessage: core[310],
          load: core[160],
        },
      },
      PinEntry: {
        PinLengthConfiguration: {
          pinLengthButton: core[214],
          pinLengthOptionTemplate: core[16],
        },
        PivotPinEntryWrapper: {
          forgotPinButton: core[132],
          EULApt1: core[67],
          EULApt2Link: core[339],
          privacyPolicy: core[225],
          termsOfUse: core[271],
        },
      },
      models: {
        base_model: {
          unkownError: core[41],
        },
        device_sorter: {
          nameSortDescription: core[37],
          devicesSortDescription: core[102],
          groupSortDescription: core[137],
        },
        setting: {
          descriptionPastTemplate: core[71], // template: title, label
          descriptionPresentTemplate: core[74], // template: title, label
          descriptionFailureTemplate: core[127], // template: title, label
        },
      },
      device_features: {
        runtime_history: {
          retrievingMonthlyHistory: core[238],
          retrievingDailyHistory: core[237],
        },
        schedule: {
          scheduleEnableSuccess: core[248],
          scheduleEnableFailure: core[247],
        },
      },
      dialogs: {
        ChooseOrDeleteDialog: {
          deleteConfirmationTemplate: core[52],
          deleteButton: core[96],
          emptyMessage: core[356],
          cancelButton: core[69],
          confirmButton: core[204],
        },
        InternetRequiredDialog: {
          internetRequiredMessage: core[305],
        },
        PaginationDialog: {
          selectPageHeader: core[250],
        },
        PivotDevicesGroupsDialog: {
          thermostatsTitle: core[280],
          cancel: core[69],
          apply: core[44],
        },
        PivotChooseDialog: {
          emptyMessage: core[356],
          cancelButton: core[69],
          confirmButton: core[204],
        },
        LanguageDialog: {
          savingLanguages: core[361],
          setViaDevice: core[360],
          selectLanguage: core[362],
        },
        PromptDialog: {
          defaultCancelText: core[69],
          defaultConfirmText: core[204],
          defaultRequiredWarningText: core[363],
        },
        ConfirmationDialog: {
          defaultCancelText: core[69],
          defaultConfirmText: core[204],
        },
        LoginConfirmationDialog: {
          defaultCancelText: core[69],
          defaultConfirmText: core[204],
          passwordLabel: core[370],
        },
      },
      PivotWelcomePageBrandLogo: {
        welcomeToPivot: core[306],
      },
      PivotOccupancyModeExtra: {
        occupied: core[201],
        unoccupied: core[298],
        occupiedTimeRemaining: core[202],
      },
      MainMenuWithoutColor: {
        note: core[357],
        selectBuldingToEnable: core[198],
        createGroupButton: core[93],
        dashboardLabel: core[95],
        alertsLabel: core[35],
        eventsLabel: core[124],
        usersLabel: core[303],
        usernamePasswordPrompt: core[222],
        manageUsersTitle: core[179],
        buildingConfigurationLabel: core[64],
        exitDemoLabel: core[125],
        appSettingsLabel: core[43],
        supportAndFeedbackLabel: core[268],
        enrollNewDeviceButton: core[116],
      },
      SettingListView: {
        applyToAdditionalStatsTemplate: core[45],
        yes: core[307],
        no: core[192],
      },
      validatable: {
        labelRequiredTemplate: core[5],
        labelDoesNotMatchTemplate: core[3],
        labelInvalidTemplate: core[4],
        labelExactLengthCharsTemplate: core[8],
        labelMinLengthCharsTemplate: core[13],
        labelMaxLengthCharsTemplate: core[9],
        labelMinNumberTemplate: core[12],
        labelMaxNumberTemplate: core[1],
      },
      NoDevicesPageCommercial: {
        noStatsEnrolledYetTemplate: core[17],
        tapEnrollCallToActionTemplate: core[151],
        enrollNewDevicebutton: core[116],
      },
      PivotDemoBanner: {
        saveDoesNotOccur: core[98],
      },
      PivotDemoMessage: {
        demoMessage: core[358],
        okButton: core[204],
      },
      EnrollmentWizard: {
        ChooseADevice: {
          notCompatibleMessage: core[285],
        },
        EnrollDevice: {
          getCodeDescriptionTemplate: core[287],
          otherBuildingDescription: core[288],
          getCodeButton: core[134],
          buildingDashboardButton: core[65],
        },
        EnrollingDevice: {
          enrollmentSuccessfulTemplate: core[267],
          enrollmentFailed: core[117],
        },
        EnrollmentWizardAppBar: {
          enroll: core[386],
          enrolling: core[387],
        },
        WizardFooter: {
          cancel: core[69],
        },
      },
      BuildingInfoTile: {
        loadingBuildingTemplate: core[162],
      },
      AppBarButtons: {
        deleteButton: core[96],
        editButton: core[364],
        saveButton: core[241],
        saveAsButton: core[242],
        loadButton: core[160],
      },
      PhoneHeader: {
        mobileUserLabel: core[371],
      },
      SupportCode: {
        supportCodeLabel: core[372],
      },
      UserAgent: {
        chromeVersion: core[367],
        unknownVersion: core[369],
        webView: core[368],
      },
    },
  };
};

export default stringsProvider;



// WEBPACK FOOTER //
// ../nx-components/src/Locales/stringsProvider.js